import gql from "graphql-tag";

export const MY_MApp_ANCHORS = gql`
  query myResilienceAnchors {
    myResilienceAnchors
  }
`;
